import { Link } from 'react-router-dom';
import { FaWix, FaSquarespace, FaCodepen } from 'react-icons/fa';
import { IoLogoVercel } from 'react-icons/io5';
import { SiSanity } from 'react-icons/si'
import usePageTitle from '../hooks/usePageTitle';
import StandardLink from '../tools/StandardLink';

import("../styles/home.scss");

function Home() {
  usePageTitle('Home | Dochano');

  return (
    <section id="Home">

      <div id="denverBackdrop">
        <p>Embracing Continued Professional Development</p>
      </div>

      <h2>Deeper Dive</h2>
      <div className="flex">
        <div>
          <img src={require('../assets/AI.png')} alt="AI Robot at computer discussing with live human." />
          <h3>Embracing Artificial Intelligence</h3>
          <p>I am taking the time to dive deeper into AI. Using Python, I have created a machine 
            learning process that will learn from prior answers to guess an animal. I have also 
            implemented a system that will identify words within PDF files to a CSV so I can 
            identify which files have a given word or phrase rather than opening each up 
            individually. Beyond this, I am diving deep into an Engineers place with-in an 
            AI driven world. An Engineers job is to make life easier for themselves and the 
            wider world. So it is inevitable that Engineers will develop routes to streamline 
            the Software Engineering landscape. Again and again the human empathy stands out 
            as the trait that will see Engineers and Managers through.</p>
          <Link to="exploration#python">Check out the Python section on Exploration page</Link>
          <p><Link to="learning">Continued Learning can be found on Learning page</Link></p>
        </div>

        <div>
          <img src={require('../assets/code.png')} alt="Screenshot of VSCode" />
          <h3>Website Builders</h3>
          <p>From composing sites using Notepad or a VI editor has provided me with a keen eye 
            on bloated code. Tools such as Dreamworks would add additional mark-up which 
            increased file size and hindered performance. There are more and more services and 
            tools available to help Engineers develop faster and maintain the code easier. I 
            enjoy jumping in and discussing services and tools available. Similar to AI, 
            there are sure to be areas that might lack now but the future seems bright in 
            where they can help excel with the right historical knowledge.</p>
          <ul>
            <li><FaSquarespace /> Squarespace - cost to go live, intro version lacks features.</li>
            <li><FaWix /> WIX - free with ads, robust features to start with.</li>
            <li><IoLogoVercel /> Vercel - sophisticated developer start with flexibilty and multiple options.</li>
            <li><SiSanity /> Sanity.io - headless CMS tool to make database management easy and directly available to API's.</li>
          </ul>
        </div>
        
        <div>
          <img src={require('../assets/group-discussion.png')} alt="silhouettes of men and women headshot connected together like a network" />
          <h3>Management</h3>
          <p>The skills I developed in my management career is growing the team through 
            communication and collaboration to help each other reach new goals. I have 
            enhanced CodePen potential new hire quiz to identify a developers skills. 
            Been successful in growing team members careers into leadership roles or taking 
            on a new opportunity within the company to help them pursue their interests. 
            I have even taking the time to create meaningful Retrospectives for the team 
            to get to know one another and learn from past experiences.</p>
          <Link to="RetroTime">Learn more on my Retrospective Journey</Link>
          <p><FaCodepen /> CodePen - Check out my personal playground at <StandardLink href="https://codepen.io/grjohnson" isNewWindow={true}>grjohnson</StandardLink></p>
        </div>
      </div>

      <div id="Local">
        <img src={require('../assets/denver-buildings.jpg')} alt="Buildings off of Curtis Street in Downtown Denver" />
        <div>
          <h2>Colorado Based</h2>
          <p>I love the Denver Metro Area and am looking for a new role as a Software Engineering Manager. 
            I have over 24 years FinTech experience working for a Communify Fincentric. Which I have seen 
            evolve from <StandardLink href="https://www.crunchbase.com/organization/wall-street-on-demand" isNewWindow={true}>Wall Street On Demand to Markit</StandardLink> (6/2010), 
            then to <StandardLink href="https://www.crunchbase.com/organization/ihs-markit" isNewWindow={true}>IHS Markit</StandardLink> (7/2016), 
            to <StandardLink href="https://www.crunchbase.com/organization/s-p-global" isNewWindow={true}>S&P Global</StandardLink> (2/2022), 
            to finally reside at <StandardLink href="https://communify.com/" isNewWindow={true}>Communify Fincentric</StandardLink> (10/2024). 
            Building research sites for the largest financial companies around the world.</p>
        </div>
      </div>

    </section>
  );
}

export default Home;